import { getQFromQuery } from '../../utils'
import { ClusteringKMeansSettingsQueryParams } from '../types'

export const generateQuery = ({ geomField, clusters, baseQuery, atLocation }: ClusteringKMeansSettingsQueryParams) => {
  // There is a hard limit because VARCHAR(MAX) is 64 kb and it reaches the limit with around 500 points
  const lastQuery = getQFromQuery(baseQuery) || 1
  const clusteringQquery = `\tWITH input_limit AS (
\t\tSELECT
\t\t\t*
\t\tFROM
\t\t\t__q1
\t\t-- This analysis is limited to 100-500 input points.
\t\t-- Removing this limit may throw the error "Value too long for character"
\t\t-- Redshift can handle values up to 64kb for VARCHAR type.
\t\tLIMIT
\t\t\t100
\t),
\tcollect AS (
\t\tSELECT
\t\t\tST_COLLECT(${geomField}) AS geom
\t\tFROM
\t\t\tinput_limit
\t),
\tclustering AS (
\t\tSELECT
\t\t\t${atLocation}.ST_CLUSTERKMEANS(collect.geom, ${clusters}) clusters
\t\tFROM
\t\t\tcollect, input_limit
\t)
\tSELECT
\t\to.cluster::VARCHAR AS cluster,
\t\tST_GEOMFROMGEOJSON(JSON_SERIALIZE(o.geom)) AS geom
\tFROM
\t\tclustering c, c.clusters o`
  const query = `${baseQuery},
__q${lastQuery + 1} AS (
${clusteringQquery}
)
SELECT * FROM __q${lastQuery + 1}`
  return query
}
